// src/utils/api-helpers/SalesCatalogService.helpers.ts
// Helper functions for Sales Catalog endpoints

import { CancelablePromise } from '../../api/core/CancelablePromise';
import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export class SalesCatalogServiceHelpers {
  /**
   * Get sales locations (active branches, filtered by user restriction)
   */
  public static getLocations(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-catalog/locations',
    });
  }

  /**
   * Get active payment methods for sales
   */
  public static getPaymentMethods(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales-catalog/payment-methods',
    });
  }
}
